module.exports = __webpack_public_path__ + "assets/img/question.db54d013.png";